module.exports = __webpack_public_path__ + "static/media/logo-lemedia-white.abd7655c.svg";